"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var versions_1 = require("./versions");
function cleanServiceClassname(key, size) {
    if (!key) {
        return key;
    }
    var className = versions_1.hasVersion(key) ? versions_1.stripVersion(key) : key;
    return className.includes(size) ? className : "" + className + size;
}
exports.default = cleanServiceClassname;
